module.exports = __webpack_public_path__ + "img/trend-up-01.11f68cd4.svg";